import { render, staticRenderFns } from "./resumeList.vue?vue&type=template&id=1b0f6c4c&scoped=true&"
import script from "./resumeList.vue?vue&type=script&lang=ts&"
export * from "./resumeList.vue?vue&type=script&lang=ts&"
import style0 from "./resumeList.vue?vue&type=style&index=0&id=1b0f6c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f6c4c",
  null
  
)

export default component.exports